import React from "react";
import PrintSummary from "./PrintSummary";

//https://github.com/gregnb/react-to-print/issues/404
export class PrintSummaryWrapper extends React.Component {
  render() {
    return <PrintSummary orderHistory={this.props.orderHistory}></PrintSummary>;
  }
}
